define('presentation/welcome/viewModels/onboardingFooterViewModel',[
    'common/promises/promiseFactory',
    'presentation/welcome/common/onboardingNavigationManager',
], function() {
    return function() {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _i18n = require('i18next');

        let _disposables = [];
        let _onboardingNavigationManager = null;

        let _onForwardArrowClicked = () => _promiseFactory.deferIndefinitely(promise => promise.resolve(false));

        self.isNavigateToPreviousPageVisible = ko.observable(true);
        self.isNavigateToNextPageVisible = ko.observable(true);
        self.isNavigateToNextPageActive = ko.observable(false);
        self.isNextPageArrowVisible = ko.observable(true);
        self.nextPageButtonText = ko.observable(_i18n.t('onboardingFooter:nextStep'));
        self.isSpinning = ko.observable(false);

        self.navigateToPreviousPage = () => {
            _onboardingNavigationManager.previousPage();
        };

        let _navigationClicked = true;
        self.navigateToNextPage = () => {
            return _promiseFactory.defer((deferredObject) => {
                if (_navigationClicked) {
                    deferredObject.resolve();
                    return;
                }

                _navigationClicked = true;
                self.isSpinning(true);
                const minimumSpinTime = 1000 + new Date().getTime();

                _onForwardArrowClicked()
                    .fail(deferredObject.reject)
                    .done(shouldNavigate => {
                        if (shouldNavigate) {
                            setTimeout(() => {
                                _onForwardArrowClicked = () => _promiseFactory.deferIndefinitely(promise => promise.resolve(false));
                                _onboardingNavigationManager.nextPage();
                                deferredObject.resolve();
                            }, minimumSpinTime - new Date().getTime());
                        } else {
                            _navigationClicked = false;
                            self.isSpinning(false);
                            deferredObject.resolve();
                        }
                    });
            });
        };

        self.detached = () => {
            _onboardingNavigationManager.detached();
            _disposables.forEach(subscription => subscription.dispose());
            _disposables = [];
        };

        self.activate = (data) => {
            const OnboardingNavigationManagerConstructor = require('presentation/welcome/common/onboardingNavigationManager');
            _onboardingNavigationManager = new OnboardingNavigationManagerConstructor();
            _onboardingNavigationManager.init();

            const setSelfValues = (element) => {
                const dataElement = data[element];
                if (dataElement !== undefined) {
                    const selfElement = self[element];
                    if (ko.isObservable(dataElement)) {
                        selfElement(dataElement());
                        _disposables.push(dataElement.subscribe(selfElement));
                    } else {
                        selfElement(dataElement);
                    }
                }
            };
            setSelfValues('isNavigateToNextPageActive');
            setSelfValues('isNextPageArrowVisible');

            if (data.nextPageButtonText !== undefined) {
                setSelfValues('nextPageButtonText');
            }

            if (data.isNavigateToPreviousPageVisible !== undefined) {
                setSelfValues('isNavigateToPreviousPageVisible');
            } else {
                self.isNavigateToPreviousPageVisible(_onboardingNavigationManager.isPreviousPageValid());
            }

            if (data.isNavigateToNextPageVisible !== undefined) {
                setSelfValues('isNavigateToNextPageVisible');
            } else {
                self.isNavigateToNextPageVisible(_onboardingNavigationManager.isNextPageValid());
            }

            if (data.onForwardArrowClicked) {
                _onForwardArrowClicked = data.onForwardArrowClicked;
            }

            // page resolves whether to advance and handles navigation.
            // i.e., navigate to an out-of-flow page
            if (data.onNextPageClicked) {
                self.navigateToNextPage = data.onNextPageClicked;
            }

            if (data.onBackArrowClicked) {
                self.navigateToPreviousPage = data.onBackArrowClicked;
            }

            return _initialize();
        };

        const _initialize = () => {
            _navigationClicked = false;
            _promiseFactory.wait();
        };
    };
});

